import React from 'react';

import { Card, CardBody, CardIcon, CardHeader, CardFooter } from 'components/Card';
import { RichIconBackground, colors } from 'components/RichIconBackground';

/**
 * Balance card. Used to display balance information (e.g. Tremendous Balance)
 *
 * @param {Object} props
 * @param {string} props.title Title of the card
 * @param {React.Component} props.icon Icon component
 * @param {keyof colors} props.iconColor Color of the icon
 * @param {React.ReactNode} [props.footer] Optional footer content
 * @param {React.Component} props.children Children
 */
export function BalanceCard({ title, icon, iconColor, footer, children }) {
    return (
        <Card>
            <CardIcon icon={<RichIconBackground color={iconColor}>{icon}</RichIconBackground>} />
            <CardHeader>
                {title && <p className="bold text-primary fs-16 leading-6 ellipsis m-0">{title}</p>}
            </CardHeader>
            <CardBody as="p" sx={{ fontSize: '48px', lineHeight: '56px' }} className="bold text-primary">
                {children}
            </CardBody>
            {footer && <CardFooter>{footer}</CardFooter>}
        </Card>
    );
}

export default BalanceCard;
